export default "__VITE_ASSET__BeETnAaO__"